import {createSlice} from '@reduxjs/toolkit';

import {UserFeature, UserFeatureStatus} from '~shared/models/wiki';

import {enableUserFeature, disableUserFeature, getUserFeatures} from './thunks';

interface UserFeaturesState {
    items: UserFeature[];
    isInited: boolean;
    error: boolean;
}

const initialState: UserFeaturesState = {
    items: [],

    isInited: false,
    error: false,
};

export const {reducer, actions} = createSlice({
    name: 'user-features',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(disableUserFeature.fulfilled, (state, {meta}) => {
                const item = state.items.find((item) => item.code === meta.arg.feature);

                if (item) {
                    Object.assign(item, {status: UserFeatureStatus.Disabled});
                }
            })
            .addCase(enableUserFeature.fulfilled, (state, {meta}) => {
                const item = state.items.find((item) => item.code === meta.arg.feature);

                if (item) {
                    Object.assign(item, {status: UserFeatureStatus.Enabled});
                }
            })
            .addCase(getUserFeatures.fulfilled, (state, {payload}) => {
                state.items = payload.results;
                state.isInited = true;
                state.error = false;
            })
            .addCase(getUserFeatures.pending, (state) => {
                state.error = false;
            })
            .addCase(getUserFeatures.rejected, (state) => {
                state.error = true;
            }),
});
